// @ts-nocheck
import React from 'react';

import * as styles from './styles';
import { Popper } from './Popper';
import type { PopperPlacementType } from '@material-ui/core/Popper';

import { HelpRounded } from '@mui/icons-material';

interface IState {
  anchorEl: HTMLElement | null;
  iconIsHovered: boolean;
  popperIsHovered: boolean;
}

interface IProps {
  children: React.ReactNode;
  placement: PopperPlacementType;
  arrow: boolean;
  CustomIcon?: any;
  className?: string;
  onIconMouseEnter?: () => void;
  paperClassName?: string;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export class Tooltip extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      anchorEl: null,
      iconIsHovered: false,
      popperIsHovered: false,
    };
  }

  private handleIconMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    const { onIconMouseEnter } = this.props;
    const { currentTarget } = event;
    this.setState({ anchorEl: currentTarget, iconIsHovered: true });

    if (onIconMouseEnter) {
      onIconMouseEnter();
    }
  };

  private handleIconMouseLeave = () => {
    setTimeout(() => {
      this.setState({ iconIsHovered: false });
    }, 150);
  };

  private handleMouseEnter = () => this.setState({ popperIsHovered: true });

  private handleMouseLeave = () => this.setState({ popperIsHovered: false });

  public render() {
    const { iconIsHovered, anchorEl, popperIsHovered } = this.state;
    const { arrow, placement, children, className, CustomIcon, paperClassName } = this.props;
    const Icon = CustomIcon || HelpRounded;

    return (
      <span className={className || ''}>
        <div className={styles.iconWrapper} onMouseEnter={this.handleIconMouseEnter} onMouseLeave={this.handleIconMouseLeave}>
          <Icon className={styles.svgIcon(iconIsHovered || popperIsHovered)} />
        </div>
        <Popper
          arrow={arrow}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          open={iconIsHovered || popperIsHovered}
          placement={placement}
          anchorEl={anchorEl}
          paperClassName={paperClassName}
        >
          {children}
        </Popper>
      </span>
    );
  }
}
